<template>
  <label>
    <div
      class="custom-textarea"
      :class="{
        'is-invalid': state === false,
        'is-valid': state === true,
        'not-empty': value,
      }"
    >
      <div class="wrap">
        <div
          class="mirror"
          v-html="`${value.replace(/\r\n|\r|\n/g, '<br>')}<br>`"
        ></div>
        <textarea
          :value="value"
          :placeholder="placeholder"
          class="form-control"
          :class="{
            'is-invalid': state === false,
            'is-valid': state === true,
            'not-empty': value,
          }"
          @input="$emit('input', $event.target.value)"
          @keyup.ctrl.enter="$emit('ctrl_enter')"
        >
        </textarea>
      </div>
    </div>
  </label>
</template>

<script>
const props = {
  value: {
    type: String,
    default: '',
  },
  state: {
    type: Boolean,
    default: undefined,
  },
  placeholder: {
    type: String,
    default: '',
  },
}
export default { props }
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

$max-height: 80px; // textarea max height
label {
  width: 100%;
  cursor: text;
  margin: 0;
}

.form-control {
  &.is-invalid {
    background-image: unset;
  }
}

.custom-textarea:focus-within,
.custom-textarea.not-empty {
  background-color: map-get($theme-colors, 'gray08') !important;
  border-color: map-get($theme-colors, 'purple05') !important;
}

.custom-textarea {
  align-items: center;
  background: white;
  border: 1px solid map-get($theme-colors, 'gray01');
  border-radius: 30px;
  display: flex;
  flex-grow: 1;
  line-height: initial;
  margin-bottom: 0;
  max-height: 100%;
  min-height: 55px;
  overflow: hidden;
  position: relative;
  word-break: break-all;
  width: 100%;

  &.is-invalid {
    background-color: map-get($theme-colors, 'red-opacity') !important;
    border-color: map-get($theme-colors, 'metric-low') !important;
    padding-right: calc(1.5em + 0.75rem);
    background-repeat: no-repeat;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }

  &:focus {
    box-shadow: 0 0 6px
      transparentize(map-get($theme-colors, 'octonary01'), 0.16);
  }

  .wrap {
    position: relative;
    width: 100%;

    .mirror {
      max-height: $max-height;
      padding: 0 10px;
      width: 100%;
      opacity: 0;
    }

    textarea {
      bottom: 0;
      border: none;
      height: 100%;
      left: 0;
      margin-bottom: 0;
      max-height: $max-height;
      outline: none;
      padding: 0 10px;
      position: absolute;
      resize: none;
      right: 0;
      top: 0;
      width: 100%;
      word-break: break-word;
      line-height: initial;
      height: initial !important;

      &.is-invalid {
        background-color: map-get($theme-colors, 'red-opacity0') !important;
      }

      &.not-empty {
        background-color: map-get($theme-colors, 'gray08') !important;
        border-color: map-get($theme-colors, 'purple05') !important;
      }
    }

    textarea:focus {
      background-color: map-get($theme-colors, 'gray08') !important;
      border-color: map-get($theme-colors, 'purple05') !important;
    }
  }
}
</style>
